import { ItemCategoryTypes, PartTypes, LabourTimeTypes, QuoteItemStatusTypes } from '@/enums'
import QuoteTotalsMethodMixin from './QuoteTotalsMethodMixin'
import QuoteNotificationMixin from './QuoteNotificationMixin'
import QuoteItemsMixin from './QuoteItemsMixin'
import { mapGetters, mapActions } from 'vuex'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import { syncPartPaintLoading } from '../helpers/PartsCheckSyncPartHelper'

const moduleName = 'quotes'

export default {
  mixins: [
    QuoteTotalsMethodMixin,
    QuoteItemsMixin,
    QuoteNotificationMixin
  ],
  computed: {
    partTotal() {
      if (this.mixinEntity) {
        return this.calculateItemCategoryTotal(this.mixinEntity.quotingMethod, this.mixinEntity.parts, ItemCategoryTypes.PART)
      }
    },
    ...mapGetters('quotes', {
      snapshotDiff: 'snapshotDiff',
      quoteInsurer: 'quoteInsurer',
      ntarLoadingItems: 'ntarLoadingItems',
      ntarOtherLoadingItems: 'ntarOtherLoadingItems',
      ntarLoadingValues: 'ntarLoadingValues',
      partsCheckSettingExists: 'partsCheckSettingExists',
      partsCheckSetting: 'partsCheckSetting'
    }),
    isNtar() {
      return (
        this.innerValue.labourType === LabourTimeTypes.NTAR ||
        this.innerValue.labourType === LabourTimeTypes.LTAR ||
        this.innerValue.labourType === LabourTimeTypes.eMTA
      )
    }
  },
  methods: {
    ...mapActions(moduleName, ['getExternalSetting']),
    updateValue(index, item) {
      // if (item && item.deleteOtherItem && item.itemQuantity > 0) {
      //   item.itemQuantity = item.itemQuantity * -1
      // }
      this.updateTotal()
    },
    updateMarkup(index, item) {
      if (this.items && !item.deleteOtherItem) {
        const itemToUpdate = this.innerValue.parts.find((i) => i.quoteItemId === item.quoteItemId)
        const markup = this.getMarkupPercent(item)
        itemToUpdate.markupValue = roundAwayFromZero(item.value + item.value * (markup / 100))
      }
      this.updateTotal()
    },
    onPartConditionChange(item) {
      if (this.items) {
        const itemToUpdate = this.innerValue.parts.find((i) => i.quoteItemId === item.quoteItemId)
        const markup = this.getMarkupPercent(item)
        itemToUpdate.markupValue = roundAwayFromZero(item.value + item.value * (markup / 100))
        this.addUpdatePartPaintLoading(item)
      }
      this.updateTotal()
    },
    getMarkupPercent(item) {
      let markup = 0
      switch (item.mark) {
        case PartTypes.NEW.value:
          markup = this.innerValue.newMarkup
          break
        case PartTypes.USED.value:
          markup = this.innerValue.usedMarkup
          break
        case PartTypes.EXCH.value:
          markup = this.innerValue.exchangeMarkup
          break
        case PartTypes.RECR.value:
          markup = this.innerValue.recoreMarkup
          break
        case PartTypes.RECD.value:
          markup = this.innerValue.reconditionedMarkup
          break
        case PartTypes.ALTN.value:
          markup = this.innerValue.usedMarkup
          break
        case PartTypes.AFT.value:
          markup = this.innerValue.afterMarketMarkup
          break
        case PartTypes.CAFT.value:
          markup = this.innerValue.afterMarketMarkup
          break
        case PartTypes.AFTA.value:
          markup = this.innerValue.afterMarketMarkup
          break
        case PartTypes.PAR.value:
          markup = this.innerValue.parallelMarkup
          break
      }
      return markup
    },
    async addUpdatePartPaintLoading(partItem) {
      if (!this.isNtar || !this.ntarLoadingItems || !this.quoteInsurer) {
        return
      }
      await syncPartPaintLoading({
        partItem,
        quoteEntity: this.innerValue,
        nextLineNumber: this.nextLineNumber,
        ntarLoadingItems: this.ntarLoadingItems,
        quoteInsurer: this.quoteInsurer,
        getDefaultPaintItem: this.getDefaultPaintItem,
        deletePaintLoadingItem: this.deletePaintLoadingItem
      })
    },
    deletePaintLoadingItem(item) {
      let originalItemStatus = item.itemStatus
      if (item.isNew) {
        const itemIndex = this.innerValue.labours
          .map(function (obj) {
            return obj.quoteItemId
          })
          .indexOf(item.quoteItemId)
        if (itemIndex >= 0) {
          this.innerValue.labours.splice(itemIndex, 1)
        }
      } else {
        item.deleted = true
        item.isDeleted = true
        item.itemStatus = QuoteItemStatusTypes.Deleted
      }
      this.updateTotal()
      this.$toast.open({
        message: `Item <span class="is-italic">${item.itemDesc}</span> deleted`,
        type: 'is-danger',
        position: 'is-top',
        actionText: 'Undo',
        onAction: () => {
          if (item.isNew) {
            this.innerValue.labours.splice(this.innerValue.labours.length, 1, item)
            // this.items.splice(this.items.length, 1, item)
          } else {
            item.deleted = false
            item.isDeleted = false
            item.itemStatus = originalItemStatus
          }
          this.updateTotal()
        }
      })
    },
    async getDefaultPaintItem(itemNo) {
      const filter = {
        countryId: Guid.empty(),
        companyId: this.value.companyId,
        query: itemNo,
        butterflyCode: '',
        scheduleId: this.vehicle.scheduleId || '',
        bodyId: this.vehicle.bodyId || '',
        bodySize: '',
        paintGroup: this.vehicle.paintGroup || '',
        variantId: 0,
        nvic: '',
        sortColumn: '',
        sortOrder: '',
        pageIndex: 1,
        pageSize: 1
      }
      const paintItem = await QuoteService.getAvailableLabourItems(filter, this.value.labourType.toLowerCase())
      return paintItem
    }
  }
}
